<template>
    <div>
        <v-container fluid>
            <v-card>
                <v-app-bar dark color="primary">
                    <v-toolbar-title>
                        <span><v-icon class="mr-3" dark>mdi-cogs</v-icon></span>
                        <span class="title">Learning Resources</span>
                    </v-toolbar-title>
                </v-app-bar>
                <v-container height="700px" fluid>
                    <v-row>
                        <v-col cols="12" md="12" lg="12" class="text-center">
                            <v-data-table :headers="headers" :items="items">
                                <template v-slot:item.download="{ item }">
                                    <v-btn href="/blank.pdf" target="_blank" icon
                                           text>
                                        <v-icon color="green">mdi-file-download</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "LearningResources",
        data() {
            return {
                headers: [
                    {
                        text: 'Sl. No', align: 'center', sortable: false, value: 'id', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Resource Name', align: 'center', sortable: false, value: 'name', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Download', align: 'center', sortable: false, value: 'download', selectedCheckbox: true,
                        toggle: false
                    },
                    ],
                items: [
                    {
                        id:1,
                        name:'Learning Resource 1',
                        download: true
                    },
                    {
                        id:2,
                        name:'Learning Resource 2',
                        download: true
                    },
                    {
                        id:3,
                        name:'Learning Resource 3',
                        download: true
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
